// extracted by mini-css-extract-plugin
export default {"imageWrapper":"VigboPrintModal__imageWrapper--1l_RN","closeIcon":"VigboPrintModal__closeIcon--1g7Hz"};